import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Image, ImageComponent } from '@teamfoster/sdk/image';
import { ContentPage } from 'src/app/content/models';
import { LandingPage } from 'src/app/landing-pages/models';
import { MuseumCollection } from 'src/app/museum-collections/models';
import { News } from 'src/app/news/models';
import { NewsDatePipe } from 'src/app/news/pipes/news-date.pipe';

@Component({
    selector: 'app-page-list-card',
    imports: [ImageComponent, NewsDatePipe, RouterLink],
    templateUrl: './page-list-card.component.html',
    styleUrl: './page-list-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageListCardComponent {
  title = input<string>();
  type = input<string>();
  date = input<string | null>();
  image = input<Image | undefined>();
  routerLink = input<string | string[]>();
}
